
import React from 'react';
import { TableBody } from '@/components/ui/table';
import { AttendeeRow } from './row';
import EmptyRow from './EmptyRow';
import { Attendee } from '@/types/attendee';

interface AttendeeTableBodyProps {
  attendees: Attendee[];
  onCheckInSuccess: (attendee: Attendee, timestamp: string) => void;
  onDirectUpdate?: (code: string, updates: any) => Promise<any>;
  onSilentUpdate?: (attendee: Attendee) => void;
  showContribution: boolean;
}

const AttendeeTableBody: React.FC<AttendeeTableBodyProps> = ({ 
  attendees, 
  onCheckInSuccess,
  onDirectUpdate,
  onSilentUpdate,
  showContribution
}) => {
  return (
    <TableBody className="divide-y divide-gray-100 dark:divide-gray-800">
      {attendees.length === 0 ? (
        <EmptyRow colSpan={showContribution ? 9 : 8} />
      ) : (
        attendees.map(attendee => (
          <AttendeeRow
            key={attendee.code}
            attendee={attendee}
            onCheckInSuccess={onCheckInSuccess}
            onDirectUpdate={onDirectUpdate}
            onSilentUpdate={onSilentUpdate}
            showContribution={showContribution}
          />
        ))
      )}
    </TableBody>
  );
};

export default React.memo(AttendeeTableBody);
